import { useEffect, useRef } from 'react';
import config from '../../config';
import { promptGoogleOneTap } from '../../services/oauthProviders';

const GoogleOneTapPrompt = ({ onCredential, disabled = false }) => {
  const promptedRef = useRef(false);
  const hasGoogleConfig = Boolean(config.oauth.googleClientId)
    || (typeof window !== 'undefined' && Boolean(window.__STUDIOAEYE_TEST_GOOGLE_CLIENT_ID || window.google?.accounts?.id));

  useEffect(() => {
    if (disabled || !hasGoogleConfig || promptedRef.current) {
      return undefined;
    }

    let cancelled = false;

    promptGoogleOneTap({
      onCredential: (response) => {
        if (!cancelled) {
          onCredential?.(response);
        }
      },
    })
      .then(() => {
        if (!cancelled) {
          promptedRef.current = true;
        }
      })
      .catch((err) => {
        console.debug('Google One Tap prompt unavailable:', err.message || err);
      });

    return () => {
      cancelled = true;
    };
  }, [disabled, hasGoogleConfig, onCredential]);

  return null;
};

export default GoogleOneTapPrompt;
